import { ChevronRight } from "lucide-react";

export const iconMap = {
  none: null,
  arrowRight: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        width="24"
        height="24"
        fill="white"
        fillOpacity="0.01"
        style={{ mixBlendMode: "multiply" }}
      />
      <path
        d="M13.5 4.5L12.4275 5.54475L18.1125 11.25H3V12.75H18.1125L12.4275 18.4298L13.5 19.5L21 12L13.5 4.5Z"
        fill="#161616"
      />
    </svg>
  ),
  document: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none">
      <rect
        width="24"
        height="24"
        fill="white"
        fillOpacity="0.01"
      />
      <path
        d="M22.5 18.75L21.4395 17.6895L19.5 19.629V13.5H18V19.629L16.0605 17.6895L15 18.75L18.75 22.5L22.5 18.75Z"
        fill="white"
      />
      <path
        d="M13.5 21H6V3.00001H12V7.50001C12.0011 7.89749 12.1596 8.27835 12.4406 8.55941C12.7217 8.84046 13.1025 8.99887 13.5 9.00001H18V11.25H19.5V7.50001C19.5027 7.40144 19.484 7.30346 19.4451 7.21282C19.4063 7.12218 19.3482 7.04105 19.275 6.97501L14.025 1.72501C13.959 1.65176 13.8778 1.59371 13.7872 1.55486C13.6966 1.51601 13.5986 1.4973 13.5 1.50001H6C5.60253 1.50116 5.22166 1.65957 4.94061 1.94062C4.65955 2.22168 4.50115 2.60254 4.5 3.00001V21C4.50115 21.3975 4.65955 21.7783 4.94061 22.0594C5.22166 22.3405 5.60253 22.4989 6 22.5H13.5V21ZM13.5 3.30001L17.7 7.50001H13.5V3.30001Z"
        fill="white"
      />
    </svg>
  ),
};
